import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import {
  FaqInterface,
  FaqItemInterface,
} from 'src/shared/entities/faq/faq.schema'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import {
  generateEntityWithChildIds,
  generateId,
} from '../utils/generate-base-entity'

export function createFaq(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): FaqInterface {
  return {
    ...generateEntityWithChildIds(EntityTypeEnum.Faq, parentId, masterBlockId),
    showIcons: true,
    mobileShowIcons: true,
    iconClassName: 'fas fa-chevron-circle-up',
    iconColor: 'rgba(24, 24, 24, 1)',
    backgroundColor: 'rgba(241, 244, 248, 1)',
    titleColor: 'rgba(24, 24, 24, 1)',
    titleFontSize: 16,
    spaceBetweenItems: 10,
    itemBorderRadius: 5,
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    itemPadding: {
      paddingTop: 15,
      paddingRight: 15,
      paddingBottom: 15,
      paddingLeft: 20,
    },
    mobileItemPadding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 15,
    },
  }
}

export function createFaqItem(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
  creationItemNumber = 1,
): FaqItemInterface {
  const entity: FaqItemInterface = {
    ...generateEntityWithChildIds(
      EntityTypeEnum.FaqItem,
      parentId,
      masterBlockId,
    ),
    creationItemNumber,
    title: '',
  }

  if (masterBlockId) {
    entity.masterBlockId = masterBlockId
  }

  return entity
}
